import React, { useState } from "react";
import { useSelector } from "react-redux";

import { visitsHeadList } from "../../../../utils/TableHeadList";
import MobileActionHeader from "../../../../components/UI/headingsUI/MobileActionHeader";
import FilterSearch from "../../../../components/common/FilterSearch";
import { visitSearch } from "../../../../utils/tableSearchList";
import { VisitFilterOptions } from "../../utils/complaintFilter.config";
import ImageSlider from "../../../../components/UI/viewDialogs/ImageSlider";
import VisitHistoryFIlter from "./VisitHistoryFIlter";
import { filterTableColumns } from "../../../../utils/tableHeaderConfigh";
import { adminRoles } from "../../../../utils/adminRoles";
import VisitTableView from "./VisitTableView";
import { formatVisitExcelData } from "../../utils/excelFormatters";
import { VisitDialog } from "../VisitDialog/VisitDialog";

const VisitsList = ({ visitsData }) => {
  const [viewDialogDetails, setViewDialogDetails] = useState({});
  const [imageSliderPics, setImageSliderPics] = useState([]);
  const [imageSliderCurrentIndex, setImageSliderCurrentIndex] = useState();

  const copyData = useSelector((state) => state.data.copyData);
  const isCopyData = copyData.length > 0;

  // ...............get  excel data............
  const excelData = formatVisitExcelData(copyData);
  const excelConfig = {
    data: excelData,
    fileName: "Visits_Report",
    sheetName: "Visits",
  };

  const filterVisitHeadList = filterTableColumns({
    headList: visitsHeadList,
    roleConfig: {
      Supervisor: adminRoles,
    },
  });

  const closeViewDialog = () => {
    setViewDialogDetails({ ...viewDialogDetails, open: false });
  };

  const openImageSlider = (Pics) => {
    closeViewDialog();
    setImageSliderPics(Pics);
  };

  const closeImageSlider = () => {
    setImageSliderPics([]);
    setViewDialogDetails({ ...viewDialogDetails, open: true });
  };

  return (
    <>
      <MobileActionHeader title="Visits" />
      <div className="flex justify-between items-center">
        <VisitHistoryFIlter />
        {isCopyData ? (
          <FilterSearch
            categories={VisitFilterOptions}
            searchCategories={visitSearch}
            excelConfig={excelConfig}
          />
        ) : (
          ""
        )}
      </div>
      <VisitTableView
        setViewDialogDetails={setViewDialogDetails}
        filterVisitHeadList={filterVisitHeadList}
      />

      {viewDialogDetails?.open && (
        <VisitDialog
          closeDialog={closeViewDialog}
          visit={viewDialogDetails.data}
          openImageSlider={openImageSlider}
          setImageSliderCurrentIndex={setImageSliderCurrentIndex}
          setVisitViewDetails={setViewDialogDetails}
        />
      )}
      {imageSliderPics.length !== 0 && (
        <ImageSlider
          title="Complaint Photos"
          images={imageSliderPics}
          imageSliderCurrentIndex={imageSliderCurrentIndex}
          closeDialogBox={closeImageSlider}
        />
      )}
    </>
  );
};
export default VisitsList;
